import Vue from 'vue'
import Router from 'vue-router'
import Init from '@/pages/init'
import Welcome from '@/pages/velkommen'
import Projects from '@/pages/projekter'
import Project from '@/pages/projekt'
import Maps from '@/pages/kort'
import Default from '@/pages/default'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'default',
      component: Default
    },
    {
      path: '/init/:key',
      name: 'init',
      component: Init,
      params: { key: '' }
    },
    {
      path: '/velkommen',
      name: 'velkommen',
      component: Welcome
    },
    {
      path: '/projekter',
      name: 'projekter',
      component: Projects
    },
    {
      path: '/projekt/:id',
      name: 'projekt',
      params: { id: '' },
      component: Project
    },
    {
      path: '/kort',
      name: 'kort',
      component: Maps
    }
  ],
  // mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js